import { z } from 'zod'
import type { Application } from '#/domain/application/Application'
import type { ApplicationDto as ApplicationDtoSpec } from '#/infrastructure/api/generated'
import type { Assert, SpecContract } from '#/infrastructure/api/SpecContract'
import { zApplicationDto } from '#/infrastructure/api/generated/zod.gen'

export const ApplicationDtoSchema = zApplicationDto
  .extend({
    // The spec types Id as an optional UUID, but the domain needs it and fixtures use plain keys
    Id: z.string(),
    // The spec allows a number or a numeric string, but the API sends a number
    SortOrder: z.number(),
  })
  .transform((raw): Application => ({
    id: raw.Id,
    slug: raw.Slug,
    title: raw.Title ?? undefined,
    description: raw.Description ?? undefined,
    tag: raw.Tag ?? undefined,
    link: raw.Link ?? undefined,
    image: raw.Image,
    permission: raw.Permission ?? undefined,
    buttonOnly: raw.ButtonOnly ?? undefined,
    sortOrder: raw.SortOrder,
  }))

export type ApplicationResponseDto = z.input<typeof ApplicationDtoSchema>
export type ApplicationDtoSpecContract = Assert<
  SpecContract<ApplicationResponseDto, ApplicationDtoSpec>
>

export function toDomain(raw: ApplicationResponseDto): Application {
  return ApplicationDtoSchema.parse(raw)
}

export function toDomainList(raw: ApplicationResponseDto[]): Application[] {
  return raw.map(toDomain)
}
